import { render, staticRenderFns } from "./TeacherAttendanceCountDashboard.vue?vue&type=template&id=82237456&scoped=true&"
import script from "./TeacherAttendanceCountDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherAttendanceCountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82237456",
  null
  
)

export default component.exports